import { useEffect, useRef } from 'react'
import { Dimensions } from 'types'
import useMediaSprite from '../../../hooks/use-media-sprite'
import { MediaInfo } from '../../../types'
import useStripFrameCount from '../hooks/use-strip-frame-count'
import { Canvas } from './style'

const SCALE = 2

type Props = {
    dimensions: Dimensions
    loops?: number
    mediaInfo: MediaInfo
    reversed?: boolean
    source: File | string
}

const MediaTrimmerStripCanvas = ({ dimensions, loops = 1, mediaInfo, reversed = false, source }: Props) => {
    const width = dimensions.width * SCALE
    const height = dimensions.height * SCALE
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const numFrames = useStripFrameCount(mediaInfo, width, height)
    const sprite = useMediaSprite(source, Math.round(width / numFrames), mediaInfo.fps, true)

    useEffect(() => {
        if (!canvasRef.current || !sprite) return

        const canvas = canvasRef.current
        const context = canvas.getContext('2d')
        const aspectRatio = sprite.frameWidth / sprite.frameHeight
        const frameWidth = Math.round(height * aspectRatio)
        const frameIndexes: number[] = []

        canvas.height = height
        canvas.width = width

        for (let i = 0; i < numFrames; i++) {
            const progress = (i / numFrames) * loops
            const frame = sprite.frameIndexes[Math.floor(progress * sprite.numFrames) % sprite.numFrames]

            frameIndexes.push(frame)
        }

        if (reversed) {
            frameIndexes.reverse()
        }

        frameIndexes.forEach((frame, i) => {
            const x = (frame % sprite.columns) * sprite.frameWidth
            const y = Math.floor(frame / sprite.columns) * sprite.frameHeight

            context?.drawImage(
                sprite.canvas,
                x,
                y,
                sprite.frameWidth,
                sprite.frameHeight,
                i * frameWidth,
                0,
                frameWidth,
                height
            )
        })
    }, [canvasRef, height, loops, numFrames, reversed, sprite, width])

    return <Canvas ref={canvasRef} />
}

export default MediaTrimmerStripCanvas
